export const contactActions = {
  SEND_CONTACT_FORM_PENDING: 'SEND_CONTACT_FORM_PENDING',
  SEND_CONTACT_FORM_SUCCESS: 'SEND_CONTACT_FORM_SUCCESS',
  SEND_CONTACT_FORM_ERROR: 'SEND_CONTACT_FORM_ERROR',
};
